import { normalizeStatus } from '../services/api';

export function parseMeterDate(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  const isoDay = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoDay)) {
    const d = new Date(`${isoDay}T12:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Which date field applies for the current status page. */
export function getDateFilterHint(pageStatus) {
  const s = normalizeStatus(pageStatus);
  if (s === 'Accepted') return 'accepted';
  if (s === 'Rejected') return 'rejected';
  return 'installed';
}

export function getMeterFilterDateRaw(row, pageStatus) {
  const page = String(pageStatus || 'All');
  if (page === 'All') {
    return row.dateRaw || row.createdAtRaw || '';
  }
  const s = normalizeStatus(page);
  if (s === 'Accepted' || s === 'Rejected') {
    return row.updatedAtRaw || row.dateRaw || '';
  }
  return row.dateRaw || row.createdAtRaw || '';
}

export function meterMatchesDateRange(row, pageStatus, dateFrom, dateTo) {
  if (!dateFrom && !dateTo) return true;
  const raw = getMeterFilterDateRaw(row, pageStatus);
  const d = parseMeterDate(raw);
  if (!d) return false;
  const day = startOfDay(d);
  if (dateFrom) {
    const from = startOfDay(parseMeterDate(dateFrom));
    if (from && day < from) return false;
  }
  if (dateTo) {
    const to = startOfDay(parseMeterDate(dateTo));
    if (to && day > to) return false;
  }
  return true;
}
